import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { volumes } from '../data/content';
import { SectionCTA } from './SectionCTA';
export function Volumes() {
  return <section className="bg-cream-deep px-4 py-16" aria-labelledby="vol-title" data-id="element-278" data-mp="183vkkneh6vui">
      <div className="mx-auto max-w-5xl" data-id="element-279" data-mp="181sktbnitocl">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-gold-dark" data-id="element-280" data-mp="1c4p6jb8cy0kr">What you’ll find inside</p>
        <h2 id="vol-title" className="mt-3 text-center font-serif text-[2rem] font-bold leading-tight text-ink sm:text-5xl" data-id="element-281" data-mp="1zwcqtab46de2">
          The 6 Volumes + 5 Bonuses of <span className="italic text-gold-dark" data-id="element-282" data-mp="1qud5i5t2gn5b">Sculptor’s Operating Blueprint™</span>
        </h2>

        <div className="mt-10 space-y-5" data-id="element-283" data-mp="1vt7p39yuyfqh">
          {volumes.map(v => <article key={v.number} className="rounded-3xl bg-ink p-6 text-white sm:p-10" data-id="element-284" data-mp="1vvkcw3rarkbg">
              <div className="grid gap-6 md:grid-cols-[1fr_1.1fr] md:gap-10" data-id="element-285" data-mp="fhaqvgaj27ns">
                <div data-id="element-286" data-mp="kfvttnh5z5fx">
                  <p className="font-serif text-lg font-bold uppercase tracking-[0.2em] text-gold" data-id="element-287" data-mp="kc7yqjw2maz3">{v.number}</p>
                  <h3 className="mt-2 font-serif text-[1.65rem] font-bold leading-tight sm:text-3xl" data-id="element-288" data-mp="3j93gkpgmfhzk">{v.title}</h3>
                  <p className="mt-3 font-serif text-lg italic text-gold-light" data-id="element-289" data-mp="20oxo52yucfu">{v.tagline}</p>
                  <p className="mt-4 text-base leading-relaxed text-white/75" data-id="element-290" data-mp="3t7j9mxz7l1bp">{v.description}</p>
                </div>
                <div className="rounded-2xl bg-ink-soft p-5 sm:p-6" data-id="element-291" data-mp="b0v5babzgi73">
                  <p className="text-xs font-bold uppercase tracking-widest text-gold" data-id="element-292" data-mp="62jvv0plo9pe">{v.listLabel}:</p>
                  <ul className="mt-4 grid gap-x-5 gap-y-3 sm:grid-cols-2" data-id="element-293" data-mp="krg9reec8gxx">
                    {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-white/85" data-id="element-294" data-mp="fs3dk31ktxio">
                        <CheckCircle2Icon className="mt-0.5 h-[18px] w-[18px] shrink-0 text-gold" aria-hidden="true" data-id="element-295" data-mp="trcxndswlbrx" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
              {v.closing && <p className="mt-6 border-t border-white/10 pt-5 text-base font-semibold text-gold-light" data-id="element-296" data-mp="11s0znd9g0bmg">{v.closing}</p>}
            </article>)}
        </div>

        <SectionCTA label="I want all 6 volumes now" data-id="element-297" data-mp="1bidj125ityr0" />
      </div>
    </section>;
}